// src/services/apiService.js
import api from "../utils/axiosInstance";

export const initiateSavingBusinessData = async (payload, token) => {
  let res = null;
  try {
    const apiKey = process.env.REACT_APP_API_BASE_URL;
    const url = `${apiKey}/api/v1/save`;
    const response = await api.post(url, payload, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      res = {
        result: "success",
        message: "Saved, successfully",
        data: null,
      };
    } else {
      res = {
        result: "error",
        message: "Failed to save date, please try again.",
        data: null,
      };
    }
    return res;
  } catch (error) {
    res = {
      result: "error",
      message: "An error occurred:" + error,
      data: null,
    };

    return res;
  }
};

export const createUserAccount = async (email) => {
  let res = null;

  try {
    const apiKey = process.env.REACT_APP_API_BASE_URL;
    let payload = {
      username: email
    };

    const response = await api.post(`${apiKey}/auth/register`, payload, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200) {
      res = {
        result: "success",
        message: "User has been created successfully",
        data: null,
      };
    } else {
      res = {
        result: "error",
        message: "Failed to create user account, please try again.",
        data: null,
      };
    }
    return res;
  } catch (error) {
    if (
      error.response.data == "Email ID already exists." &&
      error.response.status === 401
    ) {
      res = {
        result: "error",
        message: "Email ID already exists.",
        data: null,
      };
    } else {
      res = {
        result: "error",
        message: "An error occurred:" + error,
        data: null,
      };
    }

    return res;
  }
};

export const loginUser = async (email, password) => {
  let res = null;

  try {
    const apiKey = process.env.REACT_APP_API_BASE_URL;
    let payload = {
      username: email.trim(),
      password: password.trim(),
    };

    const response = await api.post(`${apiKey}/auth/login`, payload, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      res = {
        result: "success",
        message: "You have logged in, successfully.",
        data: response.data,
      };
    } else if (response.status === 401 && response == "Invalid Email ID") {
      res = {
        result: "error",
        message: "Email id does not exist or incorrect !",
        data: null,
      };
    } else {
      res = {
        result: "error",
        message: "Failed to login, please try again.",
        data: null,
      };
    }
    return res;
  } catch (error) {
    if (
      error.response.data == "Invalid Email ID" &&
      error.response.status === 401
    ) {
      res = {
        result: "error",
        message: "This email address is invalid or not registered.",
        data: null,
      };
    } else if (
      error.response.data == "Invalid Credentials" &&
      error.response.status === 401
    ) {
      res = {
        result: "error",
        message: "Incorrect password. Please try again.",
        data: null,
      };
    } else {
      res = {
        result: "error",
        message: "An error occurred:" + error,
        data: null,
      };
    }

    return res;
  }
};

/**
 * Fetch Data API
 */

export const fetchData = async (endPoint) => {
  let res = null;
  try {
    const apiKey = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token");
    const response = await api.get(`${apiKey}/${endPoint}`, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      res = {
        result: "success",
        message: "Success",
        data: response.data,
      };
    } else if (response.status === 401) {
      res = {
        result: "error",
        message: response.message,
        data: null,
      };
    } else {
      res = {
        result: "error",
        message: "Somthing Went Wrong, Please try again !",
        data: null,
      };
    }

    return res;
  } catch (error) {
    if (error.response.status === 401) {
      res = {
        result: "error",
        message: error.response.message,
        data: null,
      };
    } else {
      res = {
        result: "error",
        message: "An error occurred:" + error,
        data: null,
      };
    }

    return res;
  }
};

// async function that returns data from backend
export const fetchBusinessList = async (endpoint) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.get(url, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data; // or just `return response` if you want status etc.
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

/**
 *
 * @param updating data
 * @returns
 */
export const saveBusinessData = async (endpoint, payload) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.put(url, payload, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data; // or just `return response` if you want status etc.
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

/**
 *
 * @param saving data
 * @returns
 */
export const createBusinessData = async (endpoint, payload) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    let headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
    }
  
    const response = await api.post(url, payload, {
      withCredentials: true,
      headers: headers,
    });
    return response.data; // or just `return response` if you want status etc.
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

/**
 *
 * @param upload Media Data Private
 * @returns
 */

export const uploadMediaData = async (endpoint, payload) => {
  let res = null;
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.post(url, payload, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      },
    });

    let result = response.data.data;
    if (result.isError == "false") {
      let fileName = result.fileName;
      let imageUrl = result.imageUrl;
      if (
        imageUrl.includes(
          "https://casualtech-media.s3.ap-south-1.amazonaws.com"
        )
      ) {
        res = {
          result: "success",
          message: "Uploaded, successfully",
          data: {
            imageUrl: imageUrl,
            fileName: fileName,
          },
        };
      } else {
        res = {
          result: "error",
          message: "Failed to upload, Please try again !",
          data: null,
        };
      }
    } else if (result.isError == "true") {
      res = {
        result: "error",
        message: result.message,
        data: null,
      };
    }
  } catch (error) {
    res = {
      result: "error",
      message: "API error: " + error,
      data: null,
    };
  }

  return res;
};

/**
 *
 * @param deleting data
 * @returns
 */
export const deleteData = async (endpoint) => {
  let res = null;
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.delete(url, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    res = {
      result: "success",
      message: "Deleted, Successfully.",
      data: null,
    };
  } catch (error) {
    res = {
      result: "error",
      message: "API error: " + error,
      data: null,
    };
  }

  return res;
};

/**
 * Stage Listing
 */

export const stageListing = async (endpoint) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or just `return response` if you want status etc.
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

export const forgotPassword = async (endpoint,email) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;

  try {
    const res = await api.post(url, { email });
    return res;
  } catch (err) {
    console.error(err);
  }
};

export const resetPassword = async (endpoint, payload) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;

  try {
    const res = await api.post(url, payload);
    return res;
  } catch (err) {
    const errorMessage = JSON.parse(err.request.response);
    return errorMessage;
  }
};

export const queryEmail = async (endpoint, payload) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;

  try {
    const res = await api.post(url, JSON.stringify(payload), {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (err) {
    const errorMessage = JSON.parse(err.request.response);
    return errorMessage;
  }
};

export const getDomainAvailability = async (endpoint, domain) => {

  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.get(url, {
      params: { domain },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or just `return response` if you want status etc.
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

export const setDomainName = async (endpoint, domain) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/${endpoint}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.get(url, {
      params: { domain },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or just `return response` if you want status etc.
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

